import {createApp} from 'vue'
import App from './App.vue'
import store from './store'
import router from "./router";
import VueGtag from "vue-gtag";
//import VueYandexMetrika from 'vue-v3-yandex-metrika'

import { createI18n } from 'vue-i18n'


import VueGoogleMaps from '@fawmi/vue-google-maps'

import dayjs from 'dayjs'
import plugin from 'dayjs/plugin/customParseFormat'

dayjs.extend(plugin)


const i18n  = createI18n({
    locale: 'az',
    fallbackLocale: 'az',
    messages: {
        az: require('./locales/az.json'),
        en: require('./locales/en.json'),
        ru: require('./locales/ru.json')
    }
});

const app = createApp(App).use(router);
app.use(store);
app.use(router);
app.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyD7-un0s7EHnFMh-yNDKC5xMi6pZE2cYEw'
    },
});
app.use(VueGtag, {
    config: {
        id: "G-N0WY1PVKS7"
    }
}, router);

app.use(i18n);


app.config.globalProperties.$dayjs = dayjs

/*
app.use(VueYandexMetrika, {
    id: 86051866,
    router: router,
    env: process.env.NODE_ENV
    // other options
})*/

app.mount('#app')
